import { ReactElement } from 'react';

import { Trans } from '@lingui/react/macro';
import { clsx } from 'clsx';

import styles from './GenericError.module.css';
import { ServerErrorIcon } from './ServerErrorIcon';
import { useLocale } from '../../hooks/useLocale';

export const GenericError = ({
  errorText,
  className,
  callUs,
}: {
  errorText: ReactElement;
  callUs?: boolean;
  className?: string;
}) => {
  const { isDE } = useLocale();
  return (
    <div className={clsx(styles.failurePage, className)}>
      <div className={styles.failureMessage}>
        <div className={styles.failureHeading}>{errorText}</div>
        {callUs && (
          <div className={clsx(styles.failureText)}>
            <Trans>Please give us a call on</Trans>{' '}
            {isDE ? (
              <a
                href="tel:06994323020"
                className={styles.link}
                target="_blank"
                rel="noreferrer"
              >
                069 / 9432 3020
              </a>
            ) : (
              <a
                href="tel:02037780274"
                className={styles.link}
                target="_blank"
                rel="noreferrer"
              >
                020 3778 0274
              </a>
            )}
          </div>
        )}
      </div>
      <ServerErrorIcon className={styles.failureIcon} />
    </div>
  );
};
